import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const WooCommerceDevelopmentServicesInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="WooCommerce Development Services in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Your WooCommerce Partner</Subheading>}
        heading={
          <Heading>
            WooCommerce <span tw="text-primary-500">Development Services</span>{" "}
            in Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we offer expert WooCommerce development services
            in **Dubai**, creating powerful, customizable, and scalable online
            stores powered by WordPress. Transform your business with our
            tailored WooCommerce solutions.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1607082349566-187342175e2f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // WooCommerce store setup
          "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce development
          "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Online shopping experience
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Build Your WooCommerce Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert WooCommerce Solutions in Dubai"
        description="We craft WooCommerce stores that deliver results."
        cards={[
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Custom Development",
            description: "Tailored WooCommerce stores for your brand.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Optimized",
            description: "Features designed to maximize conversions.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Scalable Stores",
            description: "Grow with flexible WooCommerce setups.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Platform",
            description: "Robust security for safe transactions.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Responsive Design",
            description: "Seamless experience across all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Experts",
            description: "Dubai’s go-to for WooCommerce development.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our WooCommerce Development Process"
        description={
          <Description>
            We build your WooCommerce store with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your business and goals.</li>
              <li>Design: Create a custom, brand-aligned layout.</li>
              <li>Development: Implement plugins and custom features.</li>
              <li>Integration: Add payment gateways and tools.</li>
              <li>Launch: Deploy a polished, high-performing store.</li>
              <li>Support: Provide ongoing updates and maintenance.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1559028012-481c04fa702d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Development workflow
          "https://images.unsplash.com/photo-1522542550221-31fd19575a2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Team collaboration
          "https://images.unsplash.com/photo-1517292987719-0369a794ec0f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce analytics
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="WooCommerce Success in Dubai"
        description="Our stores empower businesses to thrive."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Revenue Growth",
            description: "WooCommerce store increased sales by 170%.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Rapid Deployment",
            description: "Store launched in under two weeks.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Trust",
            description: "96% satisfaction with our WooCommerce work.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Sell Online?</Subheading>}
        heading="WooCommerce Development Services in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert WooCommerce development
            services in Dubai. Get a scalable, secure, and custom online
            store—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1531973576160-7125cd663d86?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Dubai cityscape
          "https://images.unsplash.com/photo-1543286386-713bdd548da4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce success
          "https://images.unsplash.com/photo-1577401239170-897942555fb3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Online store management
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
